import { motion } from "framer-motion";
import { Heart, Ear, Thermometer, HeartPulse, Gauge } from "lucide-react";
import { FaLungs, FaHeadSideCough, FaAllergies } from "react-icons/fa";

const EXAMS = [
  { icon: Heart, color: "#E5484D", label: "Cuore", desc: "Auscultazione cardiaca" },
  { icon: FaLungs, color: "#3B82F6", label: "Polmoni", desc: "Respiro e auscultazione" },
  { icon: Ear, color: "#FF8A5B", label: "Orecchie", desc: "Otoscopia guidata" },
  { icon: FaHeadSideCough, color: "#FF7EB3", label: "Gola", desc: "Esame della gola" },
  { icon: FaAllergies, color: "#8B5CF6", label: "Cute", desc: "Immagini della pelle" },
  { icon: Thermometer, color: "#10B981", label: "Temperatura", desc: "Rilevazione corporea" },
  { icon: HeartPulse, color: "#5B2C91", label: "Frequenza cardiaca", desc: "Battito e ritmo" },
  { icon: Gauge, color: "#0EA5E9", label: "Parametri vitali", desc: "Saturazione e misurazione della pressione" },
];

export default function ExamsSection() {
  return (
    <section id="esami" className="bg-white py-20 sm:py-28" data-testid="exams-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 rounded-full bg-[#F6F4FA] px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] text-[#5B2C91]"
          >
            <span className="h-2 w-2 rounded-full bg-[#D4F84A]" />
            Esami
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 22 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="font-heading mt-5 text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#1F152E]"
            data-testid="exams-title"
          >
            L’esame fisico arriva fino a casa
          </motion.h2>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mt-10 overflow-hidden rounded-[2rem] lg:rounded-[2.5rem] bg-[#F6F5FE] ring-1 ring-[#5B2C91]/8 shadow-[0_20px_60px_rgba(91,44,145,0.10)]"
        >
          <img
            src="/generated/tytocare-kit-probes.png"
            alt="Dispositivo TytoCare con le sonde: fotocamera e termometro, otoscopio, stetoscopio e abbassalingua"
            className="w-full h-auto object-contain"
            data-testid="exams-device-image"
          />
        </motion.div>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5">
          {EXAMS.map((e, i) => {
            const Icon = e.icon;
            return (
              <motion.div
                key={e.label}
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.06, ease: [0.16, 1, 0.3, 1] }}
                className="group rounded-3xl bg-white p-5 sm:p-6 ring-1 ring-[#5B2C91]/8 shadow-[0_8px_30px_rgb(91,44,145,0.05)] transition-transform duration-300 hover:-translate-y-1.5"
                data-testid="exam-card"
              >
                <span
                  className="inline-flex h-12 w-12 items-center justify-center rounded-2xl"
                  style={{ backgroundColor: `${e.color}18`, color: e.color }}
                >
                  <Icon className="h-6 w-6" />
                </span>
                <h3 className="font-heading mt-4 text-lg font-semibold text-[#1F152E]">{e.label}</h3>
                <p className="mt-1 text-sm text-[#6B6280]">{e.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
